import React, { useEffect, useState } from 'react'
import { useAlert } from '../../../../context/AlertContext';
import kioskCheckinServices from '../kioskCheckinServices';
import { Dialog, DialogContent } from '@mui/material';
import moment from 'moment';

function ScheduleQueueSelectComponent({selectedQueue,setSelectedQueue,setActiveStep}) {

    const [queueList,setQueueList] = useState(null);
    const [dialogStatus,setDialogStatus] = useState(false);

    const {AppAlert} = useAlert();

    const getQueueList = () =>{
        kioskCheckinServices.getScheduleQueueList().then(res=>{
            setQueueList(res.data);
        }).catch(error=>{
            AppAlert(error.msg,"error")
        })
    }

    useEffect(()=>{
        getQueueList();
    },[])

    const selectQueue = (queue) =>{
        setSelectedQueue(queue)
        setActiveStep(1);
    }
    

    return (
        <>
            {queueList &&
                <div className='list-group'>
                    {queueList.map(queue=>
                        <span key={queue.id}>
                            
                                    <button type="button" onClick={()=>selectQueue(queue)} className="list-group-item list-group-item-action">
                                        <div>{queue.title}</div>
                                    </button>
                                                                         
                        </span>
                    )}

                    
                </div>
            }

        </>
        
    )
}

export default ScheduleQueueSelectComponent